$(document).ready(function(){
   var select1 =  $('.variants-items.indexing-1 .variants_color input:checked').val();
     var select2 =  $('.variants-items.indexing-2 .variants_color input:checked').val();
     var select3 =  $('.variants-items.indexing-3 .variants_color input:checked').val();
   $('.variants-items.indexing-1 span.selected_title').html(select1);
    $('.variants-items.indexing-2 span.selected_title').html(select2);
    $('.variants-items.indexing-3 span.selected_title').html(select3);
  $(document).on('change','.variants-items .variants_color input',function(){
     var select1 =  $('.variants-items.indexing-1 .variants_color input:checked').val();
     var select2 =  $('.variants-items.indexing-2 .variants_color input:checked').val();
     var select3 =  $('.variants-items.indexing-3 .variants_color input:checked').val();
     var three = select1 +' / '+ select2 +' / '+ select3;
      if (three == select1 +' / '+ 'undefined' +' / '+ 'undefined'){
         var select_all = select1;
          console.log(select_all);
        }
        else if(three == select1 +' / '+ select2 +' / '+ 'undefined'){
          var select_all = select1 +' / '+ select2;
          console.log(select_all);
        }
        else{
           var select_all = select1 +' / '+ select2 +' / '+ select3;
          console.log(select_all);
        }
    $('.variants-items.indexing-1 span.selected_title').html(select1);
    $('.variants-items.indexing-2 span.selected_title').html(select2);
    $('.variants-items.indexing-3 span.selected_title').html(select3);
    $('#variant-listbox option').each(function(){
      var eachElements = $(this).attr('option_name');
      var dataQty = $(this).data('quantity');
      if(select_all == eachElements){

        if(dataQty > 0){
          $('.add-to-cart button').removeAttr('disabled','');
          $('.add-to-cart button span').text('ADD TO CART');
          $('.klaviyo-bis-trigger').addClass('hide_notify_btn')
        }else{
          $('.add-to-cart button').attr('disabled','disabled');
          $('.add-to-cart button span').text('SOLD OUT');
          $('.klaviyo-bis-trigger').removeClass('hide_notify_btn')
        }
        
        $(this).addClass('selected');
        $(this).attr('selected','selected');
      }
      else{
        $(this).removeClass('selected');
        $(this).removeAttr('selected','selected');
      }
    });
    var variants_image_src = $('#variant-listbox option.selected').attr('variants-image-src');
    $('.product-page--thumb img').each(function(){
      var image_thumb_src = $(this).attr('data-variants');
      if(variants_image_src == image_thumb_src ){
        $(this).trigger('click');
      }
      else{
      
      }
    });
  });

$('#variant-listbox option:first').each(function(index, element){
    let varQty = $(element).data('quantity');
    if(varQty > 0){
      $('.add-to-cart button').removeAttr('disabled');
      $('.add-to-cart button span').text('ADD TO CART');
    } else {
      $('.add-to-cart button').attr('disabled','disabled');
      $('.add-to-cart button span').text('SOLD OUT');
    }
    return false;
});
  
$('.variants_color input[type="radio"]:first').prop('checked', true);

  
  $('.main-wrapper-photo-video-section').slick({
      arrows:true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      adaptiveHeight:true,
      prevArrow: '<button class="fancybox-button fancybox-button--arrow_left"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg></button>',
     nextArrow: '<button class="fancybox-button fancybox-button--arrow_right"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg></button>',
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    // custom tabs js >>>
    $('.product_tab h2').on('click',function(){
      var data_Heading = $(this).attr('data_heading');
      // alert(data_Heading);
      $('.product_tab_content').each(function(){
       var data_contant = $(this).attr('data_contant');
        if(data_Heading == data_contant){
          $(this).parents().toggleClass('activate_ing');
          // $(this).addClass('activate_ing');
          $(this).toggle(500);
        }
        else{
           $(this).parents().removeClass('activate_ing');
          $(this).hide();
          // $(this).removeClass('activate_ing');
        }
      });
    });
    // product page js 
    $('.main-image_wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      prevArrow: '<button class="fancybox-button fancybox-button--arrow_left"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke=" #d17264" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
     nextArrow: '<button class="fancybox-button fancybox-button--arrow_right"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke=" #d17264" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
      adaptiveHeight:true,
      asNavFor: '.product-page--thumbs-container_'
    });
    $('.product-page--thumbs-container_').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.main-image_wrapper',
      dots: false,
      centerMode: false,
      arrows: true,
       prevArrow: '<button class="fancybox-button fancybox-button--arrow_left"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke=" #d17264" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
     nextArrow: '<button class="fancybox-button fancybox-button--arrow_right"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke=" #d17264" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
      focusOnSelect: true,
       responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ]
     
    });
    	$('[data-fancybox="gallery"]').fancybox({
		buttons : [
			'slideShow',
			'close'
		],
		slideShow : {
			autoStart : true
		}
	});
  
});



// javascript code 
